import React, { useEffect, useState } from 'react';
import { getSolutionsToPoduct, getBudget } from "../../service/ApiServicioTecnico";
import { Link } from 'react-router-dom';
import { useCatalogRoute } from '../../contexts/CatalogRouteContext';
import { catalogPath } from '../../config/catalogSections';
import { useSolutionChain } from '../../hooks/useSolutionChain';
import AccordionsGroup from '../accordion/AccordionsGroup';
import styled from 'styled-components';
import ModalMailTurno from '../modal/ModalMailTurno';
import ProductCardEspecial from '../card/ProductCardEspecial';
import { assetUrl } from '../../utils/assets';

export default function RepairSelection({ product }) {

    // La solución abierta viene de la URL; su cadena de ancestros dice qué
    // acordeones hay que desplegar.
    const { solutionId } = useCatalogRoute();
    const { openIds } = useSolutionChain(product?.producto?.id, solutionId);

    const [failure, setFailure] = useState(null);
    const [budget, setButget] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModalRetiro, setShowModalRetiro] = useState(false);
    
    
    useEffect(() => {
        if (!product) return;

        const fetchSolutions = async () => {
            // Las dos llamadas van por separado: que falle el presupuesto no debe
            // dejar sin soluciones a la vista (ni al revés).
            try {
                const responseSolutions = await getSolutionsToPoduct(product.producto.id);
                setFailure(Array.isArray(responseSolutions) ? responseSolutions : []);
            } catch (error) {
                console.error('Error obteniendo soluciones:', error);
                setFailure([]);
            }

            try {
                const responseBudget = await getBudget(product.producto.id);
                setButget(Array.isArray(responseBudget) ? responseBudget : []);
            } catch (error) {
                console.error('Error obteniendo el presupuesto:', error);
                setButget([]);
            }
        };

        fetchSolutions();
    }, [product]);

    if (!product) {
        return <h3 style={{ textAlign: 'center', margin: '2rem 0rem' }}>Seleccione una Marca y un Producto para ver su ficha técnica</h3>;
    }

    const handleShowModal = () => setShowModal(true); // Función para mostrar el modal
    const handleCloseModal = () => setShowModal(false); // Función para cerrar el modal

    const handleShowModalRetiro = () => setShowModalRetiro(true);
    const handleCloseModalRetiro = () => setShowModalRetiro(false);

    const { producto } = product;

    return (
        <StyledRepairSelection>
            <div className="containerRepair">
                <div className="row" style={{width: '100%'}}>
                    <div className="col-sm-3 col-md-6 col-lg-4" >
                        <div className="row">
                            <div className="col-md-6 col-lg-12">
                                <img
                                    src={assetUrl(producto.imagen_grande)}
                                    style={{ padding: '1rem 0rem', width: '100%' }}
                                    alt={`Imagen de ${producto.nombre_producto}`}
                                />
                                
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 col-md-12 col-lg-5">
                        {failure && failure.length > 0 ? 
                        <AccordionsGroup solutions={failure} parent={null} openIds={openIds}/>
                        : <SinReparaciones />}
                    </div>
                    
                    <div className="col-sm-3 col-md-6 col-lg-3">
                        <div className="containerBudget">
                            <h3 className='titleBudget'>REPARACIÓN STANDARD</h3>
                            { budget && budget.length > 0 && (
                                <>
                                    <h3 className='priceBudget'>USD {budget?.[0]?.reparacion_standard?.precio ?? ''} + iva</h3>
                                    <div className="containerPdfBudget btn" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                        {/* <Link to={`${process.env.REACT_APP_TS_URL}/${budget[0].reparacion_standard.attachment}`}> */}
                                            <p className='subTitleBudget' style={{margin: '0rem 1rem'}}>Detalle de Presupuesto</p>
                                            <i className="fa-solid fa-cloud-arrow-down"></i>
                                        
                                    </div>

                                    <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                        <div className="modal-dialog modal-xl">
                                            <div className="modal-content">
                                            <div className="modal-header">
                                                <h2 className="modal-title fs-5" id="exampleModalLabel">Presupuesto Standard</h2>
                                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                            </div>
                                            <div className="modal-body" style={{textAlign: 'center'}}>
                                            {budget?.[0]?.reparacion_standard?.attachment ? (
                                                <iframe
                                                    title="Presupuesto Standard"
                                                    src={`${process.env.REACT_APP_TS_URL}/api/${budget[0].reparacion_standard.attachment}`}
                                                    frameBorder="0"
                                                    style={{ width: '100vh', height: '100vh' }}
                                                ></iframe>
                                            ) : (
                                                <p>No hay presupuesto disponible para mostrar.</p>
                                            )}                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className='containerButton'>
                                {/* <button className='btn btn-secondary buttonSecondary'>Presupuesto Mantenimiento Standard</button>
                                <button className='btn btn-secondary buttonSecondary'>Mantenimiento Preventivo</button> */}
                                <button 
                                    className='btn btn-secondary buttonSecondary'
                                    onClick={handleShowModal} // Al hacer clic, muestra el modal
                                    >
                                    Solicitar Turno
                                </button>
                                <button 
                                    className='btn btn-secondary buttonSecondary'
                                    onClick={handleShowModalRetiro} // Al hacer clic, muestra el modal
                                    >
                                    Solicitar Retiro
                                </button>
                            </div>
                        </div>
                        <div className="containerkit">
                            <ProductCardEspecial product={producto} type="kit"/>
                        </div>
                    </div>
                    
                </div>
               
            </div>
            <ModalMailTurno show={showModal} handleClose={handleCloseModal} title={'Solicitar Turno por una Reparación'} tipo={"turno"}/>
            <ModalMailTurno show={showModalRetiro} handleClose={handleCloseModalRetiro} title={'Solicitar Turno para Retiro'} tipo={"retiro"}/>
        </StyledRepairSelection>

    );
}

/**
 * Los selects ya no ofrecen equipos sin reparaciones, pero a esta pantalla se
 * sigue llegando por el buscador por modelo o por un link compartido. En lugar de
 * un cartel sin salida, se ofrece lo que ese mismo equipo sí tiene.
 */
function SinReparaciones() {
    const { brandSlug, productSlug } = useCatalogRoute();

    const alternativas = [
        { section: 'repuestos', label: 'Ver repuestos', icon: 'fa-solid fa-gear' },
        { section: 'kitMantenimientos', label: 'Ver kits de mantenimiento', icon: 'fa-solid fa-gears' },
        { section: 'manuales', label: 'Ver manuales', icon: 'fa-solid fa-book-open' },
        { section: 'accesorios', label: 'Ver accesorios', icon: 'fa-solid fa-plug' },
    ];

    return (
        <StyledSinReparaciones>
            <h5 className="titulo">Todavía no hay reparaciones cargadas para este equipo</h5>
            <p className="ayuda">
                Podés pedir un turno con los botones de esta misma página, o ver el resto
                del contenido del equipo:
            </p>
            <div className="alternativas">
                {alternativas.map(({ section, label, icon }) => (
                    <Link
                        key={section}
                        className="btn btn-outline-secondary btn-sm"
                        to={catalogPath(section, brandSlug, productSlug)}
                    >
                        <i className={icon}></i> {label}
                    </Link>
                ))}
            </div>
        </StyledSinReparaciones>
    );
}

const StyledSinReparaciones = styled.div`
    margin-top: 2rem;

    .titulo {
        font-weight: 700;
    }
    .ayuda {
        margin: 0.75rem 0rem 1rem;
    }
    .alternativas {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;

        i {
            margin-right: 0.4rem;
        }
    }
`

const StyledRepairSelection = styled.div`
    .containerRepair{
        //padding: 0rem 0rem 0rem 3rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 1.5rem;
        margin-bottom: 2rem;
        @media (min-width: 992px){
            margin-top: 0rem;
        }
    }
    .containerBudget{
        padding: 0.5rem;
        border-radius: 0.5rem;
        background-color: var(--colorPrimarioClaro);
        height: auto;
    }
    .titleBudget{
        font-size: 2rem;
        font-weight: 700;
        text-align: center;
        margin: 0.5rem 0rem;
        appercase;
        color: var(--colorSecundario);
    }
    .priceBudget{
        font-size: 2.5rem;
        font-weight: 900;
        text-align: center;
        margin: 0.5rem 0rem;
        color: var(--colorSecundario);
        background-color: #5e5673;
        border-radius: 0.5rem;
        padding: 1.5rem;
        margin: 0 auto;
        width: 90%;
    }
    .containerPdfBudget{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: var(--colorSecundario);
        margin-top: 0.3rem;
    }
    .containerButton{
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.5rem;
        margin-top: 1.5rem;
    }
    .buttonSecondary {
        margin: 0.3rem 0rem;
        width: 50%;
        font-weight: 700;
        font-size: 1.1rem;
    }
`